import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PlatformService } from '../services/platform.service';

// Apple 3.1.1: org/business account creation is not allowed in the iOS build.
// Block the route on native iOS and send the user back to login.
export const nonIOSGuard: CanActivateFn = () => {
  const platform = inject(PlatformService);
  const router = inject(Router);

  if (platform.isIOSNative()) {
    router.navigateByUrl('/login');
    return false;
  }
  return true;
};
